interface ByteLogoProps {
  className?: string;
}

export function ByteLogo({ className = 'w-6 h-6' }: ByteLogoProps) {
  return (
    <svg
      width="28"
      height="36"
      viewBox="0 0 28 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_bytelogo)">
        <g clipPath="url(#clip1_bytelogo)">
          <path
            d="M14.4827 28.9811H10.6571V24.9686H6.82557V20.956H3V3H14.4827C17.5527 3 19.9272 3.66038 21.6062 4.98113C23.2911 6.30189 24.1306 8.16981 24.1306 10.5849C24.1306 12.195 23.7408 13.5723 22.9673 14.7233C22.1938 15.8742 21.0785 16.717 19.6214 17.2579C21.3423 17.7358 22.6675 18.6164 23.6029 19.9057C24.5323 21.195 25 22.7925 25 24.6981C25 26.4214 24.5983 27.9057 23.8008 29.1572C23.0033 30.4025 21.846 31.3585 20.335 32.0126C18.8239 32.6667 17.0191 33 14.9204 33H14.4767L14.4827 28.9811ZM3 28.9811H6.82557V33H3V28.9811Z"
            fill="url(#paint0_bytelogo)"
          />
        </g>
        <path
          d="M22.6644 32.3828V35.1081H22.3087V32.3828H22.6644ZM23.5403 32.3828V32.6786H21.4346V32.3828H23.5403ZM24.0838 32.3828H24.4338L25.3267 34.6046L26.2176 32.3828H26.5695L25.4614 35.1081H25.1882L24.0838 32.3828ZM23.9696 32.3828H24.2785L24.329 34.0449V35.1081H23.9696V32.3828ZM26.373 32.3828H26.6818V35.1081H26.3224V34.0449L26.373 32.3828Z"
          fill="#525252"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_bytelogo"
          x1="-0.390404"
          y1="30.6388"
          x2="23.4851"
          y2="7.87606"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.28" stopColor="#FAA51F" />
          <stop offset="0.67" stopColor="#DE1D3B" />
          <stop offset="1" stopColor="#662C8B" />
        </linearGradient>
        <clipPath id="clip0_bytelogo">
          <rect width="28" height="36" fill="white" />
        </clipPath>
        <clipPath id="clip1_bytelogo">
          <rect width="22" height="30" fill="white" transform="translate(3 3)" />
        </clipPath>
      </defs>
    </svg>
  );
}
